<template>
  <v-container>
    <ContentHeader
      header-title="New Vendor Onboarding Management"
      back-navigation
      :back-navigation-to="'/client/manage/onboard/' + covgId"
    ></ContentHeader>
    <PtSheet>
      <WorkflowVendorSummary :covg-id="covgId" :fluid="false" />
      <div v-if="this.item.itemType">
        <component :is="resolutionUI" :covg-id="covgId" :item="item">
          Test
        </component>
      </div>
    </PtSheet>
  </v-container>
</template>

<script>
import { get } from "@/services/request";
import { workflowStepAPI } from "@/services/api";
import ContentHeader from "@/views/ContentHeader.vue";
import PtSheet from "@/components/PtSheet.vue";
import WorkflowVendorSummary from "@/views/client/WorkflowVendorSummary.vue";
import WorkflowTable from "@/views/client/WorkflowTable.vue";
import MonitorStatusResolutionUI from "@/views/client/MonitorStatusResolutionUI.vue";
import VendorReviewResolutionUI from "@/views/client/VendorReviewResolutionUI.vue";
import ErrorResolutionUI from "@/views/client/ErrorResolutionUI.vue";

export default {
  name: "WorkflowStepResolutionPage",
  components: { WorkflowTable, WorkflowVendorSummary, PtSheet, ContentHeader },
  props: ["covgId", "itemId"],
  data() {
    return {
      item: {}
    };
  },
  computed: {
    resolutionUI() {
      if (this.item.itemType) {
        switch (this.item.itemType) {
          case "MonitorStatusWorkflowItemBehavior":
            return MonitorStatusResolutionUI;
          case "VendorReviewWorkflowItemBehavior":
            return VendorReviewResolutionUI;
          default:
            return ErrorResolutionUI;
        }
      }
      return MonitorStatusResolutionUI;
    }
  },
  created() {
    this.loadItem();
  },
  methods: {
    loadItem() {
      get(workflowStepAPI.getUrl(this.itemId)).then(response => {
        if (response && response.data) {
          this.item = response.data;
        }
      });
    }
  }
};
</script>

<style scoped></style>
